module.exports = __webpack_public_path__ + "static/media/fly0237.5fcbe9a9.webp";